<script>
import _ from "lodash";

export default {
  data() {
    return {
      form: null,
      search: null,
      filters: this.fresh()
    };
  },

  watch: {
    form: {
      deep: true,
      handler() {
        this.fitlers = Object.assign(this.filters, this.parseForm(this.form));
        this.fire();
      }
    },

    search: _.debounce(function(query) {
      this.filters.search = query;
      this.fire();
    }, 500)
  },

  methods: {
    handleFormSubmit(data) {
      this.form = data;
    },

    onSearch: _.debounce(function() {
      this.fire();
    }, 500),

    clear() {
      this.filters = this.fresh();
      this.search = "";
      this.form = null;
      this.fire();
    },

    fire() {
      let clean = {};

      for (var i in this.filters) {
        if (this.filters[i]) {
          clean[i] = this.filters[i];
        }
      }

      this.$emit("filter", clean);
    }
  }
};
</script>
